// =======================================================
// SCRIPTS D'APPS DIFFÉRÉS (Amplitude, Elfsight)
// theme.liquid fait passer les scripts d'apps de Shopify par
// window.tpDelayScript : ceux d'Amplitude et d'Elfsight attendent
// le premier geste du visiteur (scroll, toucher, clic, clavier, souris).
// =======================================================

(function () {
  let enAttente = [];
  let lance = false;
  const evenements = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'mousemove', 'wheel'];

  function lancer() {
    if (lance) return;
    lance = true;

    evenements.forEach(nom => window.removeEventListener(nom, lancer, { passive: true }));

    enAttente.forEach(src => {
      const script = document.createElement('script');
      script.async = true;
      script.src = src;
      document.head.appendChild(script);
    });
    enAttente = [];
  }

  window.tpDelayScript = function (src) {
    if (lance || !/elfsight\.com|amplitude\.com/.test(src)) return false;
    enAttente.push(src);
    return true;
  };

  evenements.forEach(nom => window.addEventListener(nom, lancer, { passive: true }));
})();


// =======================================================
// CONFIGURATION ENVOYÉE PAR theme.liquid
// =======================================================

const tpConfig = (function () {
  const el = document.getElementById('tp-config');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    console.error('tp-config invalide', e);
    return {};
  }
})();


// =======================================================
// PRODUITS GLOBO : redirection vers l'accueil
// =======================================================

if (tpConfig.redirectToHome) {
  window.location.replace('/');
}


// =======================================================
// SURVEILLANCE PARTAGÉE DU DOM
// Un seul MutationObserver pour tout le fichier (au lieu de 8 sur le body),
// regroupé sur une frame, sans characterData, et qui s'arrête dès que
// plus rien n'est attendu.
// =======================================================

const attendreDansLeDom = (function () {
  const taches = new Map();
  let observer = null;
  let verificationPrevue = false;

  function verifier() {
    verificationPrevue = false;
    const maintenant = Date.now();

    taches.forEach((limite, tache) => {
      if (tache() || (limite && maintenant > limite)) {
        taches.delete(tache);
      }
    });

    if (taches.size === 0 && observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function planifier() {
    if (verificationPrevue) return;
    verificationPrevue = true;
    requestAnimationFrame(verifier);
  }

  return function (tache, delaiMax) {
    if (tache()) return;

    taches.set(tache, delaiMax ? Date.now() + delaiMax : 0);

    if (!observer) {
      observer = new MutationObserver(planifier);
      observer.observe(document.body || document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  };
})();

const estPageProduit = /\/products\//.test(window.location.pathname);


// =======================================================
// STYLES INJECTÉS
// =======================================================

document.head.insertAdjacentHTML('beforeend', `
<style>
.widget-branding {
  display: none !important;
}

#bis_product_title.bis-title-loading {
  color: transparent !important;
  position: relative;
  min-height: 1.2em;
}
#bis_product_title.bis-title-loading::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 18px;
  height: 18px;
  margin: -9px 0 0 -9px;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-top-color: #ff4fa8;
  border-radius: 50%;
  animation: bis-title-spin 0.8s linear infinite;
}
@keyframes bis-title-spin {
  to { transform: rotate(360deg); }
}
</style>
`);


// =======================================================
// PRIX TOTAL (prix × quantité)
// =======================================================

const zoneAffichage = document.querySelector('.total_prix_duplic');
const prixSource = document.querySelector('span.price');
const inputQte = document.querySelector('input[type="number"][name="quantity"], input[type="number"]');

let cloneActuel = null;
let prixBase = null;

function mettreAJourPrixTotal() {
  if (!prixSource || !zoneAffichage || !inputQte) return;

  // ─── 1. Récupérer le prix unitaire ───────────────────────────────
  let prixTexte = prixSource.textContent.trim();
  prixTexte = prixTexte.replace(/[^0-9,]/g, '').replace(',', '.');
  const prixUnitaire = parseFloat(prixTexte) || 0;

  // ─── 2. Récupérer la quantité (bornée par min et max) ────────────
  let quantite = parseInt(inputQte.value) || 1;
  const min = parseInt(inputQte.min) || 1;
  const maxValue = parseInt(inputQte.max);
  const max = Number.isNaN(maxValue) ? null : maxValue;

  let quantiteCorrigee = Math.max(quantite, min);
  if (max !== null) {
    quantiteCorrigee = Math.min(quantiteCorrigee, max);
  }

  if (quantiteCorrigee !== quantite) {
    quantite = quantiteCorrigee;
    inputQte.value = quantite;
  }

  // ─── 3. Calcul du total ──────────────────────────────────────────
  const base = prixBase || prixUnitaire;
  const surcharge = prixUnitaire - base;
  const total = base * quantite + surcharge;

  const totalAffiche = total.toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' €';

  // ─── 4. Gestion du clone ─────────────────────────────────────────
  if (cloneActuel) {
    cloneActuel.remove();
  }

  cloneActuel = prixSource.cloneNode(true);
  cloneActuel.classList.add('prix-clone-actuel');
  cloneActuel.textContent = totalAffiche;

  zoneAffichage.insertBefore(cloneActuel, zoneAffichage.firstChild);
}

// Ne s'active que sur les pages qui affichent le prix total
if (zoneAffichage && prixSource && inputQte) {
  inputQte.addEventListener('input', mettreAJourPrixTotal);
  inputQte.addEventListener('change', mettreAJourPrixTotal);
  inputQte.addEventListener('blur', mettreAJourPrixTotal);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.choicelist-item__value')) {
      setTimeout(mettreAJourPrixTotal, 180);
    }
  });

  new MutationObserver(mettreAJourPrixTotal).observe(prixSource, {
    characterData: true,
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    const t = prixSource.textContent.trim().replace(/[^0-9,]/g, '').replace(',', '.');
    prixBase = parseFloat(t) || 0;
    mettreAJourPrixTotal();
  }, 600);
}


// =======================================================
// QUANTITÉ MINIMUM
// =======================================================

document.addEventListener('DOMContentLoaded', () => {
  const quantityInputs = document.querySelectorAll(
    'quantity-selector-component input[type="number"][name="quantity"]'
  );
  if (quantityInputs.length === 0) return;

  const minQuantitySpan = document.querySelector('.quantite_minimum_valeur');
  const parsedMin = minQuantitySpan ? parseInt(minQuantitySpan.textContent.trim()) : NaN;
  const minQuantity = Number.isNaN(parsedMin) ? 1 : parsedMin;

  quantityInputs.forEach(input => {
    input.min = minQuantity.toString();

    const maxValue = parseInt(input.max);
    const max = Number.isNaN(maxValue) ? null : maxValue;

    const current = Number(input.value);
    if (!current || current < minQuantity) {
      if (max === null || minQuantity <= max) {
        input.value = minQuantity.toString();
      }
      mettreAJourPrixTotal();
    }

    // Borne la valeur entre min et max sans dispatcher d'événements
    // (évite la boucle avec le stepper du thème)
    const enforceMin = () => {
      const currentValue = Number(input.value);
      let corrigee = currentValue || minQuantity;
      corrigee = Math.max(corrigee, minQuantity);
      if (max !== null) {
        corrigee = Math.min(corrigee, max);
      }

      if (corrigee !== currentValue) {
        input.value = corrigee.toString();
        mettreAJourPrixTotal();
      }
    };

    input.addEventListener('input', enforceMin);
    input.addEventListener('change', enforceMin);
    input.addEventListener('blur', enforceMin);
    input.addEventListener('paste', () => {
      setTimeout(enforceMin, 0);
    });
  });
});


// =======================================================
// CARROUSEL MOBILE INFINI
// Les éléments sont clonés (au lieu de réécrire tout le innerHTML) :
// les originaux gardent leurs écouteurs et les copies sont ignorées
// par les lecteurs d'écran et la navigation clavier.
// =======================================================

(function () {
  const selecteurWrapper =
    '#shopify-section-template--26381509034371__section_iMx9UB .section-content-wrapper, ' +
    '#shopify-section-template--26381508772227__section_jpNBRV .section-content-wrapper';

  const wrapper = document.querySelector(selecteurWrapper);
  if (!wrapper) return;

  function initMobileCarousel() {
    if (window.innerWidth > 768 || wrapper.classList.contains('carousel-initialized')) return;

    const fragment = document.createDocumentFragment();

    Array.from(wrapper.children).forEach(enfant => {
      const copie = enfant.cloneNode(true);
      copie.setAttribute('aria-hidden', 'true');
      copie.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(el => {
        el.setAttribute('tabindex', '-1');
      });
      fragment.appendChild(copie);
    });

    wrapper.appendChild(fragment);
    wrapper.classList.add('carousel-initialized');
  }

  initMobileCarousel();

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth > 768 && wrapper.classList.contains('carousel-initialized')) {
        location.reload();
      } else {
        initMobileCarousel();
      }
    }, 250);
  });
})();


// =======================================================
// RÉORGANISATION DES SECTIONS SUR MOBILE
// Les sections sont rendues par Shopify : elles sont déjà dans le DOM
// quand ce script (defer) s'exécute, aucun observer n'est nécessaire.
// Exécuté tout de suite pour éviter un décalage visuel après affichage.
// =======================================================

(function () {
  const sectionToMove = document.getElementById('shopify-section-template--26381509034371__custom_liquid_zpntHn');
  if (!sectionToMove) return;

  const targetSection = document.getElementById('shopify-section-template--26381509034371__custom_liquid_MxajXw');
  const shopTheLook = document.getElementById('shopify-section-template--26381509034371__shop_the_look_47PwkR');

  if (window.innerWidth <= 768 && targetSection) {
    targetSection.parentNode.insertBefore(sectionToMove, targetSection);
  }

  function reorderSectionsOnMobile() {
    if (!shopTheLook || !sectionToMove.parentNode || !shopTheLook.parentNode) return;

    if (window.innerWidth < 768 && shopTheLook.nextElementSibling !== sectionToMove) {
      shopTheLook.insertAdjacentElement('afterend', sectionToMove);
    }
  }

  reorderSectionsOnMobile();

  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(reorderSectionsOnMobile, 250);
  });
})();


// =======================================================
// HEADER RÉTRÉCI AU SCROLL
// Ne touche au DOM que lorsque l'état change (et non à chaque pixel)
// =======================================================

(function () {
  const header = document.querySelector('.ai-tata-header-av1d6l2lnbtfjqjivdaigenblocka04c2b0zrjrtf');
  if (!header) return;

  const info =
    document.querySelector('#shopify-section-template--26706138825091__main') ||
    document.querySelector('#shopify-section-template--27614485348739__main');
  const slideshow = document.querySelector('#shopify-section-template--26381509034371__slideshow_UbNAnR');

  let compact = null;

  window.addEventListener('scroll', () => {
    const doitEtreCompact = window.scrollY > 44;
    if (doitEtreCompact === compact) return;
    compact = doitEtreCompact;

    header.classList.toggle('shrinked', compact);
    document.body.classList.toggle('has-fixed-header', compact);

    if (info) {
      info.style.marginTop = compact ? '190px' : '0px';
    }
    if (slideshow) {
      slideshow.style.paddingTop = compact ? '119px' : '0px';
    }
  }, { passive: true });
})();


// =======================================================
// JUDGE.ME
// Ne surveille le DOM que sur les pages qui ont un widget d'avis
// =======================================================

(function () {
  const widgetPresent = document.querySelector(
    '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-all-reviews-widget, .jdgm-rev-widg'
  );
  if (!widgetPresent && !estPageProduit) return;

  const MAX_INITIAL_REVIEWS = 5;
  let noteFormatee = false;
  let paginationConfiguree = false;
  let boutonDeplace = false;

  // Formater la note : remplacer "sur" par "/" et "." par ","
  function formatRating() {
    if (noteFormatee) return;

    const ratingElement = document.querySelector('.jdgm-rev-widg__summary-average');
    if (!ratingElement) return;

    let text = ratingElement.textContent;
    if (!text.includes(' sur ')) return;

    text = text.replace(' sur ', '/').replace('.', ',');
    const parts = text.split('/');

    if (parts.length === 2) {
      ratingElement.innerHTML = `<span style="font-size: 45px;">${parts[0]}</span><span style="font-size: 32px;">/${parts[1]}</span>`;
    } else {
      ratingElement.textContent = text;
    }

    noteFormatee = true;
  }

  // Pagination des avis
  function setupReviewsPagination() {
    if (paginationConfiguree) return;

    const reviewsContainer = document.querySelector('.jdgm-rev-widg__reviews');
    const writeReviewButton = document.querySelector('.jdgm-widget-actions-wrapper');
    const widgetContainer = document.querySelector('.jdgm-rev-widg');

    if (!reviewsContainer || !writeReviewButton || !widgetContainer) return;

    const allReviews = Array.from(reviewsContainer.querySelectorAll('.jdgm-rev'));
    const totalReviews = allReviews.length;

    if (totalReviews <= MAX_INITIAL_REVIEWS) {
      widgetContainer.appendChild(writeReviewButton);
      paginationConfiguree = true;
      return;
    }

    writeReviewButton.style.cssText = 'display: none !important;';

    allReviews.forEach((review, index) => {
      if (index >= MAX_INITIAL_REVIEWS) {
        review.style.cssText = 'display: none !important;';
      }
    });

    const seeMoreButton = document.createElement('div');
    seeMoreButton.className = 'jdgm-see-more-wrapper';
    seeMoreButton.style.cssText = 'margin-top: 40px; text-align: center; padding: 20px 0;';
    seeMoreButton.innerHTML = `
      <div class="jdgm-see-more-indicator" style="
        font-size: 14px;
        color: #ff69b4;
        margin-bottom: 12px;
        font-weight: 500;
      ">
        ${MAX_INITIAL_REVIEWS} avis sur ${totalReviews}
      </div>
      <a href="#" class="jdgm-see-more-link" role="button" style="
        display: inline-block;
        background: #ff69b4;
        color: white;
        padding: 12px 30px;
        border-radius: 25px;
        text-decoration: none;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;
      ">
        VOIR PLUS D'AVIS
      </a>
    `;

    const link = seeMoreButton.querySelector('.jdgm-see-more-link');
    link.addEventListener('mouseenter', function () {
      this.style.background = '#ff1493';
      this.style.transform = 'translateY(-2px)';
    });
    link.addEventListener('mouseleave', function () {
      this.style.background = '#ff69b4';
      this.style.transform = 'translateY(0)';
    });

    widgetContainer.appendChild(seeMoreButton);

    link.addEventListener('click', function (e) {
      e.preventDefault();

      allReviews.forEach(review => {
        review.style.cssText = 'display: grid !important;';
      });

      seeMoreButton.style.cssText = 'display: none !important;';

      writeReviewButton.style.cssText = 'display: block !important; margin-top: 40px; text-align: center; padding: 20px 0;';
      widgetContainer.appendChild(writeReviewButton);
    });

    paginationConfiguree = true;
  }

  // Déplacer le bouton "Écrire un avis" en bas après tous les avis
  function moveWriteReviewButton() {
    if (boutonDeplace) return;

    const button = document.querySelector('.jdgm-widget-actions-wrapper');
    const reviewsContainer = document.querySelector('.jdgm-rev-widg');

    if (button && reviewsContainer) {
      reviewsContainer.appendChild(button);
      boutonDeplace = true;
    }
  }

  attendreDansLeDom(function () {
    formatRating();
    setupReviewsPagination();
    moveWriteReviewButton();
    return noteFormatee && paginationConfiguree && boutonDeplace;
  });
})();


// =======================================================
// CARROUSEL TÉMOIGNAGES - carte centrale agrandie
// Uniquement pour l'ancien carrousel (sans composant
// testimonials-carousel) : plus de setInterval sur les autres pages.
// =======================================================

(function () {
  if (document.querySelector('testimonials-carousel-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm')) return;

  const carousel = document.querySelector('.ai-testimonials-carousel-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');
  if (!carousel) return;

  let lastTransform = '';

  function updateCenterCard() {
    if (window.innerWidth <= 768) {
      updateCenteredCardMobile();
    } else {
      updateCenterCardDesktop();
    }
  }

  function updateCenterCardDesktop() {
    const allCards = document.querySelectorAll('.ai-testimonials-card-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm:not(.testi-clone)');
    if (allCards.length === 0) return;

    const carouselRect = carousel.getBoundingClientRect();
    const carouselCenter = carouselRect.left + carouselRect.width / 2;

    allCards.forEach(card => {
      const cardRect = card.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      card.classList.toggle('is-center', Math.abs(carouselCenter - cardCenter) < 100);
    });
  }

  function updateCenteredCardMobile() {
    const cards = Array.from(carousel.querySelectorAll(
      '.ai-testimonials-card-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm:not(.testi-clone)'
    ));
    if (cards.length === 0) return;

    const carouselRect = carousel.getBoundingClientRect();
    const centerX = carouselRect.left + carouselRect.width / 2;

    let closestIndex = 0;
    let closestDistance = Infinity;

    cards.forEach((card, index) => {
      card.classList.remove('centeredmobile');
      const cardRect = card.getBoundingClientRect();
      const distance = Math.abs(cardRect.left + cardRect.width / 2 - centerX);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    cards[closestIndex].classList.add('centeredmobile');
  }

  updateCenterCard();

  const slider = document.querySelector('.ai-testimonials-slider-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');

  if (slider) {
    new MutationObserver(() => {
      const currentTransform = slider.style.transform;
      if (currentTransform !== lastTransform) {
        lastTransform = currentTransform;
        setTimeout(updateCenterCard, 350);
      }
    }).observe(slider, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  // Autoplay : uniquement quand l'onglet est visible
  setInterval(() => {
    if (!document.hidden) updateCenterCard();
  }, 500);

  const prevButton = document.querySelector('.ai-testimonials-prev-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');
  const nextButton = document.querySelector('.ai-testimonials-next-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');

  if (prevButton) {
    prevButton.addEventListener('click', () => setTimeout(updateCenterCard, 350));
  }
  if (nextButton) {
    nextButton.addEventListener('click', () => setTimeout(updateCenterCard, 350));
  }

  window.addEventListener('resize', updateCenterCard);
})();


// =======================================================
// DÉTECTION MAC / IPHONE
// =======================================================

if (navigator.platform.includes('Mac')) {
  document.documentElement.classList.add('is-mac');
}

if (/iPhone/i.test(navigator.userAgent)) {
  document.documentElement.classList.add('is-iphone');
}


// =======================================================
// GLOBO VIDE + PAGINATION TÉMOIGNAGES MOBILE
// =======================================================

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.gpo-product-variants').forEach(el => {
    const isEmpty = el.children.length === 0 && el.textContent.trim() === '';
    const hasNoSiblings = !el.previousElementSibling && !el.nextElementSibling;

    if (isEmpty && hasNoSiblings) {
      el.parentElement?.classList.add('gpo-product-variants-empty');
    }
  });

  const carousel = document.querySelector('testimonials-carousel-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');
  if (!carousel || window.innerWidth > 768) return;

  setTimeout(initTestimonialsPagination, 1000);

  function initTestimonialsPagination() {
    const paginationContainer = document.createElement('div');
    paginationContainer.className = 'custom-testimonials-pagination';
    paginationContainer.style.cssText = `
      display: flex !important;
      justify-content: center;
      gap: 8px;
      margin-bottom: 40px;
      padding: 10px 0;
    `;

    const cards = carousel.querySelectorAll('.ai-testimonials-card-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm:not(.testi-clone)');

    cards.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'custom-testimonials-dot';
      dot.setAttribute('data-index', index);
      dot.setAttribute('aria-label', `Aller au témoignage ${index + 1}`);
      dot.style.cssText = `
        width: 5px;
        height: 5px;
        border-radius: 50%;
        border: none;
        background-color: #ffb1d8;
        cursor: pointer;
        padding: 0;
        transition: all 0.3s ease;
      `;

      dot.addEventListener('click', () => goToSlide(index));
      paginationContainer.appendChild(dot);
    });

    carousel.parentNode.insertBefore(paginationContainer, carousel.nextSibling);

    const dots = paginationContainer.querySelectorAll('.custom-testimonials-dot');

    function goToSlide(index) {
      if (typeof carousel.goTo === 'function') {
        carousel.goTo(index);
        updateDots(index);
        return;
      }

      const nextButton = carousel.querySelector('.ai-testimonials-next-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');
      const prevButton = carousel.querySelector('.ai-testimonials-prev-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');
      const activeIndex = Array.from(dots).findIndex(dot => dot.classList.contains('active'));

      if (activeIndex < index) {
        for (let i = activeIndex; i < index; i++) {
          if (nextButton) nextButton.click();
        }
      } else if (activeIndex > index) {
        for (let i = activeIndex; i > index; i--) {
          if (prevButton) prevButton.click();
        }
      }

      updateDots(index);
    }

    function updateDots(activeIndex) {
      dots.forEach((dot, index) => {
        const actif = index === activeIndex;
        dot.style.backgroundColor = actif ? '#ff5aa5' : '#ffb1d8';
        dot.style.transform = actif ? 'scale(1.2)' : 'scale(1)';
      });
    }

    const slider = carousel.querySelector('.ai-testimonials-slider-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm');
    if (slider) {
      new MutationObserver(() => {
        const centeredCard = carousel.querySelector('.ai-testimonials-card-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm.centeredmobile');
        if (!centeredCard) return;

        const activeIndex = Array.from(cards).indexOf(centeredCard);
        if (activeIndex !== -1) {
          updateDots(activeIndex);
        }
      }).observe(slider, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
        childList: true
      });
    }

    updateDots(0);
  }
});


// =======================================================
// ÉTOILES DÉCORATIVES - SHOP THE LOOK
// =======================================================

(function () {
  const targetSection = document.getElementById('shopify-section-template--26381509034371__section_bpmee6');
  if (!targetSection) return;

  const src = 'https://cdn.shopify.com/s/files/1/0939/6545/1651/files/etoile_image.png?v=1761888412&width=48';

  const etoile = n => `
    <div class="wrap-star-shop-the-look-${n}" aria-hidden="true">
      <img class="star-shop-the-look-${n}" src="${src}" alt="" width="24" height="24" loading="lazy" decoding="async">
    </div>`;

  targetSection.insertAdjacentHTML('beforeend', etoile(4) + etoile(5) + etoile(6) + `
    <style>
      .wrap-star-shop-the-look-4,
      .wrap-star-shop-the-look-5,
      .wrap-star-shop-the-look-6 {
        position: absolute;
      }
    </style>
  `);
})();


// =======================================================
// SUPPRIMER LA CLASSE .section
// =======================================================

['shopify-section-template--26381509034371__section_bpmee6',
  'shopify-section-template--26381509034371__section_iMx9UB']
  .forEach(id => {
    document.getElementById(id)
      ?.querySelector('.section')
      ?.classList.remove('section');
  });


// =======================================================
// FORMULAIRE CRM - fichier uploadé
// Observe uniquement le bloc du formulaire. Si le bloc n'est pas
// rendu par Shopify sur la page, la recherche s'arrête après 20 s.
// =======================================================

(function () {
  const targetId = 'block-id-file-egmfpzwqih-AKzdlRHJDY1F2OXZWN__formcrm_form_gpt_QkLqry';
  const zoneFormulaire = document.querySelector('[id$="formcrm_form_gpt_QkLqry"]');

  const checkUploadedFile = fileBlock => {
    const hasContent = fileBlock.querySelector(
      '.form-crm-default--file-container, .form-crm-default--file-name, .form-crm-default--file-preview-name'
    );
    fileBlock.classList.toggle('js-file-is-uploaded', !!hasContent);
  };

  attendreDansLeDom(function () {
    const fileBlock = document.getElementById(targetId);
    if (!fileBlock) return false;

    new MutationObserver(() => checkUploadedFile(fileBlock)).observe(fileBlock, {
      childList: true,
      subtree: true
    });
    checkUploadedFile(fileBlock);
    return true;
  }, zoneFormulaire ? 0 : 20000);
})();


// =======================================================
// BACK IN STOCK - loader à la place du titre vide / "undefined"
// Pages produit uniquement : observe le titre lui-même une fois
// la modale injectée, plus tout le texte de la page.
// =======================================================

(function () {
  if (!estPageProduit) return;

  const updateTitleState = el => {
    const text = el.textContent.trim();
    el.classList.toggle('bis-title-loading', text === 'undefined' || text === '');
  };

  attendreDansLeDom(function () {
    const el = document.getElementById('bis_product_title');
    if (el && !el.dataset.bisObserve) {
      el.dataset.bisObserve = 'true';
      updateTitleState(el);
      new MutationObserver(() => updateTitleState(el)).observe(el, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    return false;
  });
})();


// =======================================================
// DATE DE LIVRAISON (J+3, pas de dimanche)
// =======================================================

(function () {
  const jours = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
  const mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  const deliveryDate = new Date();
  deliveryDate.setDate(deliveryDate.getDate() + 3);
  if (deliveryDate.getDay() === 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }
  const texte = ` ${jours[deliveryDate.getDay()]} ${deliveryDate.getDate()} ${mois[deliveryDate.getMonth()]}`;

  document.querySelectorAll('p').forEach(paragraph => {
    if (!paragraph.textContent.includes('Prochaine date de livraison disponible :')) return;

    let span = paragraph.querySelector('span');
    if (!span) {
      span = document.createElement('span');
      paragraph.appendChild(span);
    }
    span.textContent = texte;
  });
})();


// =======================================================
// ONGLETS RETRAIT / EXPÉDITION (best-sellers)
// =======================================================

(function () {
  const tabButtons = document.querySelectorAll('.ai-bestsellers-tab-button-ac2xfc282cjgwwtfazretraitexpeditionaqxzjl');
  if (tabButtons.length === 0) return;

  const viewAllLink = document.querySelector('.ai-bestsellers-view-all-ac2xfc282cjgwwtfazretraitexpeditionaqxzjl');

  function handleTabChange(tabId) {
    if (!viewAllLink) return;

    if (tabId === 'expeditions') {
      viewAllLink.href = '/collections/all';
      viewAllLink.textContent = 'TOUS LES PRODUITS EXPÉDIABLES';
      viewAllLink.onclick = () => sessionStorage.setItem('deliveryFilter', 'livraison');
    } else if (tabId === 'retraits') {
      viewAllLink.href = '/collections/all';
      viewAllLink.textContent = 'TOUS LES PRODUITS EN RETRAIT';
      viewAllLink.onclick = () => sessionStorage.setItem('deliveryFilter', 'retrait');
    }
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', function () {
      tabButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      handleTabChange(this.dataset.tab);
    });
  });
})();


// =======================================================
// FILTRE DE LIVRAISON MÉMORISÉ (boutons et liens du menu)
// =======================================================

(function () {
  const memoriser = (selecteur, valeur) => {
    document.querySelectorAll(selecteur).forEach(el => {
      el.addEventListener('click', () => sessionStorage.setItem('deliveryFilter', valeur));
    });
  };

  memoriser('.button--AWmM3NUpzYjNObE5QO__button_UFT76H', 'livraison');
  memoriser('.link-menu-bas.expedable_link', 'livraison');
  memoriser('.button--AV2czWnpEb0hIZjF6N__button_MntxNh', 'retrait');
  memoriser('.link-menu-bas.retrait_link', 'retrait');
})();


// =======================================================
// TÉMOIGNAGES : section surélevée
// =======================================================

document.querySelector('.ai-testimonials-section-acwjhtmrwnhbxmuxuoaigenblock1c66162gadaxm')
  ?.closest('.custom-section-content')
  ?.classList.add('custom-section-content--elevated');


// =======================================================
// CARROUSEL INFINI MOBILE (Swiper)
// =======================================================

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined' && document.querySelector('.infinite-carousel-section.mobile .swiper')) {
    new Swiper('.infinite-carousel-section.mobile .swiper', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 20,
      loop: true,
      grabCursor: true,
      speed: 400
    });
  }
});


// =======================================================
// COMPTEUR PANIER (sans les produits Globo)
// =======================================================

(function () {
  const allProductsGlobo = tpConfig.globoProducts || {};
  window.shopProducts = allProductsGlobo;

  const globoVariantIds = new Set();
  Object.values(allProductsGlobo).forEach(product => {
    (product.variants || []).forEach(variant => globoVariantIds.add(variant.id));
  });

  async function getCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const nonGloboItems = [];
      const globoItems = [];

      cart.items.forEach(item => {
        if (globoVariantIds.has(item.variant_id)) {
          globoItems.push(item);
        } else {
          nonGloboItems.push(item);
        }
      });

      const totalItemsWithoutGlobo = nonGloboItems.reduce((sum, item) => sum + item.quantity, 0);
      const cartHeaderCount = document.querySelector('.ai-tata-header-cart-count');
      if (cartHeaderCount) {
        cartHeaderCount.textContent = totalItemsWithoutGlobo;
        cartHeaderCount.classList.toggle('hidden', totalItemsWithoutGlobo === 0);
      }

      return {
        totalItems: totalItemsWithoutGlobo,
        uniqueItems: nonGloboItems.length,
        globoItemsCount: globoItems.length,
        cart: cart,
        nonGloboItems: nonGloboItems,
        globoItems: globoItems
      };
    } catch (error) {
      console.error('Erreur récupération panier:', error);
    }
  }

  window.getCartCount = getCartCount;

  document.addEventListener('DOMContentLoaded', function () {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      const request = args[0];
      const url = typeof request === 'string' ? request : (request && request.url) || '';
      const method = (args[1]?.method || request?.method || 'GET').toUpperCase();

      const isCartAction =
        method === 'POST' &&
        (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'));

      return originalFetch.apply(this, args).then(response => {
        if (isCartAction) {
          setTimeout(getCartCount, 100);
        }
        return response;
      });
    };
  });
})();


// =======================================================
// FORMULAIRE CRM : traduction des messages d'erreur
// Uniquement sur les pages qui contiennent le formulaire
// =======================================================

document.addEventListener('DOMContentLoaded', function () {
  const formulaires = document.querySelectorAll('[id*="formcrm"], [class*="form-crm"]');
  if (formulaires.length === 0) return;

  const translations = {
    'One or more field have an error. Please check and try again.':
      'Un ou plusieurs champs contiennent une erreur. Veuillez vérifier et réessayer.',
    'This is a required field': 'Ce champ est obligatoire'
  };

  function translateErrors() {
    document.querySelectorAll('.form-crm--error-global-message, .form-crm-default--error-text').forEach(el => {
      const original = el.textContent.trim();
      if (translations[original]) {
        el.textContent = translations[original];
      }
    });
  }

  translateErrors();

  formulaires.forEach(formulaire => {
    new MutationObserver(translateErrors).observe(formulaire, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
});
